<template>
  <div class="relative">
    <button
      @click="toggleDropdown"
      class="flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <span class="mr-2">{{ currentLocale.flag }}</span>
      <span>{{ currentLocale.name }}</span>
      <svg
        class="w-4 h-4 ml-2"
        :class="{ 'transform rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>

    <div
      v-show="isOpen"
      class="absolute right-0 z-10 w-48 mt-2 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
    >
      <div class="py-1">
        <button
          v-for="locale in availableLocales"
          :key="locale.code"
          @click="selectLocale(locale.code)"
          :class="{
            'bg-gray-100 text-gray-900': locale.code === currentLocale.code,
            'text-gray-700 hover:bg-gray-50': locale.code !== currentLocale.code
          }"
          class="flex items-center w-full px-4 py-2 text-sm text-left"
        >
          <span class="mr-3">{{ locale.flag }}</span>
          <span>{{ locale.name }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { usePage, router } from '@inertiajs/vue3'
import { setCurrentLocale } from '../../entrypoints/translations.js'
import axios from 'axios'

export default {
  name: 'LanguageSelector',
  setup() {
    const isOpen = ref(false)
    const page = usePage()

    const currentLocale = computed(() => {
      const current = page.props.locale?.current || 'en'
      const available = page.props.locale?.available || []
      return available.find(l => l.code === current) || { code: current, name: 'English', flag: '🇺🇸' }
    })

    const availableLocales = computed(() => {
      return page.props.locale?.available || []
    })

    const toggleDropdown = () => {
      isOpen.value = !isOpen.value
    }

    const selectLocale = async (localeCode) => {
      if (localeCode === currentLocale.value.code) {
        isOpen.value = false
        return
      }

      const response = await axios.put('/locale', {
        locale: localeCode
      })

      if (response.data.status === 'success') {
        setCurrentLocale(localeCode)
        
        // Visit current URL to get updated locale data
        router.visit(window.location.pathname, {
          preserveState: false,
          preserveScroll: true
        })
      }

      isOpen.value = false
    }

    const handleClickOutside = (event) => {
      if (!event.target.closest('.relative')) {
        isOpen.value = false
      }
    }

    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
    })

    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside)
    })

    return {
      isOpen,
      currentLocale,
      availableLocales,
      toggleDropdown,
      selectLocale
    }
  }
}
</script>
